
import FilterRemove from "../../../assets/filled/FilterRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FilterRemoveIcon({ className, dataTestid = "FilterRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FilterRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
